import { motion } from 'framer-motion';
import SEO from '../../components/SEO';
import heroImage from '../../assets/texture-hero.png';

const TextureDesign = () => {
    const textures = [
        { name: "Royal Play", desc: "Premium artistic designs for feature walls." },
        { name: "Stucco Antico", desc: "Classic marble-like finish with high gloss." },
        { name: "Metallic Texture", desc: "Adds a shimmer and modern touch to your room." },
        { name: "Sandstone Finish", desc: "Earthy, rough texture for a natural look." }
    ];

    return (
        <div className="min-h-screen pb-20">
            <SEO 
                title="Texture & Royal Designs Madurai" 
                description="Modern wall textures and Royal Play designs in Madurai. Transform your single wall into a focal point of art." 
            />
            
            {/* Hero Section */}
            <section className="relative h-[60vh] flex items-center justify-center overflow-hidden">
                <div className="absolute inset-0 z-0">
                    <img src={heroImage} alt="Wall Texture" className="w-full h-full object-cover" />
                    <div className="absolute inset-0 bg-blue-900/70"></div>
                </div>
                <div className="relative z-10 text-center px-4">
                    <motion.h1 
                        initial={{ opacity: 0, y: -20 }}
                        animate={{ opacity: 1, y: 0 }}
                        className="text-4xl md:text-6xl font-bold text-white mb-4"
                    >
                        Texture & Royal Designs
                    </motion.h1>
                    <motion.p 
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ delay: 0.3 }}
                        className="text-xl text-blue-100 italic"
                    >
                        "When walls become a canvas for art."
                    </motion.p>
                </div>
            </section>

            <div className="max-w-6xl mx-auto px-4 mt-20">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center mb-24">
                    <motion.div
                        initial={{ opacity: 0, x: -50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                    >
                        <h2 className="text-4xl font-bold text-blue-900 mb-8 leading-tight">Modern Wall Textures</h2>
                        <p className="text-gray-600 mb-8 leading-relaxed text-lg">
                            Bored of plain walls? Texture painting adds depth, character, and luxury to your rooms. We specialize in various Asian Paints Royal Play designs that can transform a simple wall into a stunning focal point.
                        </p>
                        <ul className="space-y-4 font-bold text-gray-700">
                            {["Custom Color Combinations", "Durable & Washable Finishes", "Professional Design Application"].map((item, i) => (
                                <li key={i} className="flex items-center space-x-3">
                                    <div className="w-3 h-3 bg-orange-600 rounded-full"></div>
                                    <span>{item}</span>
                                </li>
                            ))}
                        </ul>
                    </motion.div>
                    <motion.div 
                        initial={{ opacity: 0, scale: 0.9 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        viewport={{ once: true }}
                        className="bg-slate-50 h-[450px] rounded-[3rem] border border-slate-100 shadow-2xl flex items-center justify-center text-gray-400 italic"
                    >
                        [Texture Sample Image]
                    </motion.div>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
                    {textures.map((t, idx) => (
                        <motion.div 
                            key={idx} 
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ delay: idx * 0.1 }}
                            whileHover={{ y: -5 }}
                            className="bg-white p-8 rounded-[2rem] shadow-xl border border-slate-50 hover:border-orange-200 transition-all text-center"
                        >
                            <h3 className="text-xl font-bold text-blue-900 mb-3">{t.name}</h3>
                            <p className="text-gray-500 text-sm leading-relaxed">{t.desc}</p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default TextureDesign;
